module.exports = __webpack_public_path__ + "bin/5b85c08c89df17255cf1dbff58f0f97f.png";